import React from 'react'
import { Box } from '@mui/material'
import { Trans } from 'react-i18next'

/** Users permission step */
export const UsersPermissionsStep: React.FC = () => {
  return (
    <>
      <Trans i18nKey="emobility.tour.user-permission" components={{ strong: <strong /> }} />

      <Box mt={2}>
        <Trans i18nKey="emobility.tour.user-permission-depends" components={{ strong: <strong /> }} />
      </Box>
    </>
  )
}
